import React from 'react';
import { Plus, X } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';

export const CategoriesCard = ({ formData, setFormData, newCategory, setNewCategory }) => {
  const addCategory = () => {
    if (newCategory.trim() && !formData.categories.includes(newCategory.trim())) {
      setFormData(prev => ({
        ...prev,
        categories: [...prev.categories, newCategory.trim()]
      }));
      setNewCategory('');
    }
  };

  const removeCategory = (cat) => {
    setFormData(prev => ({
      ...prev,
      categories: prev.categories.filter(c => c !== cat)
    }));
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Categorias de Denúncia</CardTitle>
        <CardDescription>
          Defina as categorias disponíveis no formulário de denúncia
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex flex-wrap gap-2">
          {formData.categories.map((cat) => (
            <Badge key={cat} variant="outline" className="pl-3 pr-1 py-1">
              {cat}
              <button
                onClick={() => removeCategory(cat)}
                className="ml-2 hover:bg-slate-200 rounded p-0.5"
              >
                <X className="w-3 h-3" />
              </button>
            </Badge>
          ))}
        </div>

        <div className="flex gap-2">
          <Input
            value={newCategory}
            onChange={(e) => setNewCategory(e.target.value)}
            placeholder="Nova categoria..."
            onKeyPress={(e) => e.key === 'Enter' && addCategory()}
            data-testid="new-category-input"
          />
          <Button variant="outline" onClick={addCategory} data-testid="add-category-btn">
            <Plus className="w-4 h-4" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
